import classNames from 'classnames';
import React, {useEffect, useState} from 'react';
import './styles.css';
import Button from '../../GbsUI/UI/Button';
import ArrowRightIcon from '../../GbsUI/UI/icons/ArrowRight';

const ACTIONS = [
  {
    key: 'student',
    title: 'Recent Graduate',
    description: 'Incoming classes of investment bankers, buyside analysts, and management consultants',
    link: '/student/school',
    location: 'react',
    icon: '/img/signup-student.webp'
  },
  {
    key: 'signup',
    title: 'Experienced Professional',
    description: 'Finance professional with at least one year of full time post-undergrad experience',
    link: '/signup',
    location: 'legacy',
    icon: '/img/signup-new.webp'
  }
];

const StartPage = (props) => {
  const [selected, setSelected] = useState(ACTIONS[0]);

  return (
    <div className={'signup-start'}>
      <div className={'signup-start__header'}>
        <h1 className={'student-signup__title'}>Welcome to GoBuyside</h1>
        <p className={'student-signup__description'}>Which profile fits you best?</p>
      </div>
      <div className={'signup-start__actions'}>
        {ACTIONS.map((action) => (
          <label className={classNames('signup-start__action start-action', {
            'start-action--active': action.key === selected.key
          })} key={action.key}>
            <span className={'start-action__radio'}>
              <input
                type={'radio'}
                name={'action'}
                checked={action.key === selected.key}
                value={action.key}
                onChange={() => {
                  setSelected(action);
                }}
              />
              <span></span>
            </span>
            <img src={action.icon} width={240} height={240} alt={action.title}/>
            <h3 className={'start-action__title'}>{action.title}</h3>
            <p className={'start-action__description'}>{action.description}</p>
          </label>
        ))}
      </div>
      <div className={'signup-start__footer'}>
        <Button
          type={'button'}
          secondary
          className={'signup-start__button'}
          onClick={() => {
            if (selected.location === 'react') {
              props.history.push(selected.link);
            } else {
              window.location.href = selected.link;
            }
          }}
          icon={ArrowRightIcon}
          iconPosition={'right'}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

export default StartPage;
